import React, { useState } from 'react';
import {useTranslation} from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { faqContainerVariants, faqItemVariants, faqAnswerVariants } from '../../utility/framerMotionAnimations';

const FaqSection = () => {
    const {t} = useTranslation('homepage');
    
    const faqs = [
        {
            question: t('faq-section-box1.question'),
            answer: t('faq-section-box1.answer')
        },
        {
            question: t('faq-section-box2.question'),
            answer: t('faq-section-box2.answer')
        },
        {
            question: t('faq-section-box3.question'),
            answer: t('faq-section-box3.answer')
        },
        {
            question: t('faq-section-box4.question'),
            answer: t('faq-section-box4.answer')
        },
    ];

    const [activeIndex, setActiveIndex] = useState(faqs.length - 1); // Last item expanded by default

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? -1 : index);
    };

    return (
        <section className="faq-section mt-8">
            <div className="section-container m-pm-0">
                <motion.h2 
                    className="heading"
                    initial={{ opacity: 0, y: -20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                >
                    {t('faq-section-heading')}
                </motion.h2>
                
                <motion.div 
                    className="faqs-container mt-2"
                    variants={faqContainerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                >
                    {faqs.map((faq, index) => (
                        <motion.div 
                            key={index} 
                            className={`faq ${activeIndex === index ? 'show' : ''}`}
                            variants={faqItemVariants}
                            whileHover="hover"
                            onClick={() => toggleAccordion(index)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="question">
                                {faq.question}
                                <span className="float-right">
                                    {activeIndex === index ? '−' : '+'}
                                </span>
                            </div>
                            <AnimatePresence>
                                {activeIndex === index && (
                                    <motion.div 
                                        className="answer"
                                        variants={faqAnswerVariants}
                                        initial="hidden"
                                        animate="visible"
                                        exit="hidden"
                                    >
                                        {faq.answer}
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}

export default FaqSection;
